import api from "@/api";

const namespaced = true

const state = {
  onTimePerformanceUtilizationData: [],
  routes: []
}

const getters = {
  onTimePerformanceUtilizationData: (state) => state.onTimePerformanceUtilizationData,
  routes: (state) => state.routes
}

const mutations = {
  SET_ON_TIME_PERFORMANCE_UTILIZATION_DATA: (state, payload) => {
    state.onTimePerformanceUtilizationData = payload
  },
  SET_ROUTES: (state, payload) => {
    state.routes = payload
  }
}

const actions = {
  async fetchOnTimePerformanceUtilization({ commit }, payload) {
    try {
      const { data } = await api.getOnTimePerformanceUtilization(payload)

      if (data.error) {
        commit('SET_ON_TIME_PERFORMANCE_UTILIZATION_DATA', [])
        return
      }

      commit('SET_ON_TIME_PERFORMANCE_UTILIZATION_DATA', data)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getOnTimePerformanceUtilRoutes()
  
      if (data.error) {
        commit('SET_ROUTES', [])
        return
      }
  
      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }